import { render } from "./PositiveFit.vue?vue&type=template&id=ddf39ac8&scoped=true&lang=pug"
import script from "./PositiveFit.vue?vue&type=script&lang=js"
export * from "./PositiveFit.vue?vue&type=script&lang=js"

import "./PositiveFit.vue?vue&type=style&index=0&id=ddf39ac8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddf39ac8"]])

export default __exports__